import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=7b9b8c93&"
import script from "./AddOrganization.vue?vue&type=script&lang=ts&"
export * from "./AddOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports